import CloseIcon from '@material-ui/icons/Close';
import React, { Component } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import AndriodIcon from '../../Assets/images/BringYourPhone/checkCompatibility_and.png';
import IosIcon from '../../Assets/images/BringYourPhone/checkCompatibility_ios.png';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import './ImeiPopOver.scss';

type initialProps = {};
type initialState = {
    haveTrouble: boolean;
    target: any;
};

export class PopOverImeiBox extends Component<initialProps, initialState> {
    ref: any = React.createRef();
    state: initialState = {
        haveTrouble: false,
        target: null,
    };

    haveTroubleHandler = async () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Check Compatibility',
        //     actionType: 'Having Trouble',
        // });
        let var1: any = await document.getElementById('having-trouble-div');
        await this.setState({ haveTrouble: true, target: var1 });
    };
    closeTroubleHandler = () => {
        this.setState({
            target: null,
            haveTrouble: false,
        });
    };

    render() {
        return (
            <div ref={this.ref}>
                <div className="having-trouble-div" id="having-trouble-div" onClick={this.haveTroubleHandler}>
                    (<span className='underline'>here’s how to find it</span>).
                </div>
                <Overlay
                    show={this.state.haveTrouble}
                    target={this.state.target}
                    placement="bottom"
                    container={this.ref.current}
                    containerPadding={20}
                >
                    <Popover id="popover-contained">
                        <Popover.Body>
                            <div className="HaveTroubleToolTip-activation" onClick={this.closeTroubleHandler}>
                                <div className="HaveTroubleHeader">
                                    <CloseIcon onClick={this.closeTroubleHandler} className="closeIcon" />
                                    <div className="HaveTroubleHeaderText"> How to find IMEI number?</div>
                                </div>
                                <div className="haveTroubleDetaildiv">
                                    <div className="detailImgDiv">
                                        <img src={IosIcon} alt="icon" className="detailImg" />
                                    </div>
                                    <div className="detailContent">
                                        <div className="detailHead">iOS</div>
                                        <div className="detailSubText addMarginBottom">
                                            Go to Settings - General - About - IMEI
                                        </div>
                                    </div>
                                </div>
                                <div className="haveTroubleDetaildiv">
                                    <div className="detailImgDiv">
                                        <img src={AndriodIcon} alt="icon" className="detailImg" />
                                    </div>
                                    <div className="detailContent">
                                        <div className="detailHead">Android</div>
                                        <div className="detailSubText">
                                            Go to Settings - About Phone - Status - IMEI
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Popover.Body>
                    </Popover>
                </Overlay>
            </div>
        );
    }
}
export default PopOverImeiBox;
